// The chat message the outreach thread's composer hands to the Maestro.
//
// The composer does NOT send a message to the contact. Symphony has no path for the user to put raw
// text on somebody else's channel, and inventing one here would be a second, silent outreach route
// that bypasses the conversation — the same reason "Reach out" seeds a chat rather than sending, and
// the same shape the tasks screen's "Resolve with {agent}" CTA already uses (`task-resolve-message`).
//
// So what the user types is an INSTRUCTION: the agent composes, confirms and sends. The message
// carries who it is for and which thread it continues, because the agent has neither on its own —
// a bare "tell him yes" reaching a fresh chat names nobody.
//
// Mirrored 1:1 on iOS (`outreachReplyMessage`) and Android (`outreachReplyMessage`) — same wording,
// same key.

type Translate = (key: string, options?: Record<string, unknown>) => string;

export function outreachReplyMessage(
  t: Translate,
  input: { contactName: string; subject: string; body: string },
): string {
  const body = input.body.trim();
  const name = input.contactName.trim();
  const subject = input.subject.trim();
  // Interpolation must not HTML-escape: all three values are user text on their way into a chat box.
  return t('contacts.thread.replySeed', { name, subject, body, interpolation: { escapeValue: false } });
}
